import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { apiGetCall, isResultOk, dateToISO, apiPostCall } from './../../components/special/apiCall';
import { useLocale } from './../../components/special/LanguageProvider';
import ListHeader from './../../components/form/ListHeader';
import ListTable from './../../components/form/ListTable';
import RowButtons from './../../components/button/RowButtons';
import RowChangeButton from './../../components/button/RowChangeButton';
import TextDate from './../../components/text/TextDate';
import TextNumber from 'components/text/TextNumber';
import RowDeleteButton from './../../components/button/RowDeleteButton';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const TableRateList = ({history})  => {
  const [list, setList] = useState([]);  
  const [tableInfo , setTableInfo] = useState({
    tableTypeID : 0,
    tableTypeName : "",
    tableID : 0,
    tableName : "",
    readOnly : false,
    useExtraValue : false
  });  
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);
  const { t } = useLocale();
  const params = new URLSearchParams(useLocation().search); 
  
  const goBack = (tableTypeID) => {
    if (tableTypeID){
      history.push("/admin/tables?tabletypeid="+tableTypeID);
    }
    else{
      history.push("/admin/tabletypes");
    }
  }

  const loadList = async () =>{        
    let tabletypeID = params.get("tabletypeid");    
    let tableID = params.get("tableid");    
    if ((tabletypeID == null || tabletypeID <= 0) || (tableID == null || tableID <= 0)){      
      if ((tabletypeID == null || tabletypeID <= 0)){
        goBack();
      }
      else{
        goBack(tabletypeID);
      }
    }    
    else{                          
      const data = await apiGetCall(BASE_URL + '/admin/table/rate/summary/'+tabletypeID+'/'+tableID);
      if (isResultOk(data, setListError, true)){
        setTableInfo({
          tableTypeID : data.tableTypeID,
          tableTypeName : data.tableTypeName,
          tableID : data.tableID,
          tableName : data.tableName,
          readOnly : data.readOnly, 
          useExtraValue : data.extraValue
        });
        setList(data.rates);
      }    
      setListLoading(false);
    }

  }

  useEffect(() => {
    setIsPageLoading(true);
    loadList();
    setIsPageLoading(false);
  }, []);  

  const onDeleteRateClick = async(item) =>{
    setIsPageLoading(true);
    let requestResult = await apiPostCall(BASE_URL + '/admin/table/rate/remove', {TableTypeID: tableInfo.tableTypeID, TableID: item.tableID, PointDate: item.pointDate});
    if (isResultOk(requestResult, setCheckErrorItems)){
      await loadList();
    }
    setIsPageLoading(false);
  }
  
    return (    
      <div> 
        <a href={"/admin/tabletypes"}>{t("Forsendutöflur")}</a> - <a href={"/admin/tables?tabletypeid="+ tableInfo.tableTypeID}>{tableInfo.tableTypeName}</a>     
        <ListHeader title={tableInfo.tableName}>
          <div className="text-right">{!tableInfo.readOnly && <Link to={"/admin/tablerates/edit?new=true&tabletypeid="+tableInfo.tableTypeID + "&tableid=" + tableInfo.tableID} className="no-print button gray-light icon-plus pointer-edit text-14">{t("Stofna nýja punkt")}</Link>}</div>
        </ListHeader>  
        <ListTable
            error = {listError}
            isLoading = {listLoading}
            list = {list}
            colsettings = {['', '','','20px']}
            headers = {[
              t("Gildir frá"),
              t("Gildi"),              
              (tableInfo.useExtraValue ? t("Aukagildi") : ""),              
              t("")              
            ]}
            columns = {[
              (item => (<TextDate value={item.pointDate}/>)),
              (item => (<TextNumber value={item.value}/>)),
              (item => (<>{tableInfo.useExtraValue && <TextNumber value={item.value}/>}</>)),
              (item => (<>{!tableInfo.readOnly && <RowButtons>
                          <RowDeleteButton onClick={() => onDeleteRateClick(item)}/>
                          <RowChangeButton link={"/admin/tablerates/edit?tabletypeid=" + tableInfo.tableTypeID + "&tableid=" + tableInfo.tableID + "&pointdate="+ dateToISO(item.pointDate)}/>                    
                        </RowButtons>}</>))
            ]}
  
        />
    </div>
    );
};
